// extracted by mini-css-extract-plugin
export var avatarBone = "_6-5";
export var body = "_6-b";
export var bone = "_6-0";
export var brandGroup = "_6-4";
export var cardBone = "_6-i";
export var descBone = "_6-f";
export var divider = "_6-a";
export var grid = "_6-h";
export var header = "_6-2";
export var iconTagBone = "_6-8";
export var leftColumn = "_6-c";
export var leftInner = "_6-d";
export var nameBone = "_6-6";
export var navBar = "_6-3";
export var rightColumn = "_6-g";
export var rightGroup = "_6-7";
export var skeletonPulse = "_6-1";
export var tagBone = "_6-9";
export var titleBone = "_6-e";